module.exports = __webpack_public_path__ + "img/20211031.b80b6425.gif";